const { VITE_BOX_AUTH_CLIENT_ID } = import.meta.env;

class BoxOAuth2Client {
  static titleName = "Box";
  #clientId = VITE_BOX_AUTH_CLIENT_ID;
  #redirectUri = location.origin + "/box_oauth2_callback";

  constructor() {}

  async getAuthWithRedirect(transitedState) {
    const authUrl = new URL(`https://account.box.com/api/oauth2/authorize`);
    authUrl.searchParams.set("client_id", this.#clientId);
    authUrl.searchParams.set("redirect_uri", this.#redirectUri);
    authUrl.searchParams.set("response_type", "code");
    // prettier-ignore
    authUrl.searchParams.set("state", window.btoa(JSON.stringify(transitedState)));

    window.open(authUrl.toString(), "_self");
  }

  async callbackHandler(query = {}) {
    const { code, error, error_description } = query;
    if (error) {
      throw new Error(`${error}:${error_description}`);
    }
    return { access_token: code, refresh_token: "" };
  }
}

export default BoxOAuth2Client;
